import { API_JWT_BASE_URL } from '../http'

export const GET_ALL_FLEETS_API = `${API_JWT_BASE_URL}/admin/fleets/getpermissionfleet`
export const SEARCH_FLEETS_API = `${API_JWT_BASE_URL}/admin/fleets/search`
export const CREATE_FLEETS_API = `${API_JWT_BASE_URL}/admin/fleets`
export const UPDATE_FLEETS_API = `${API_JWT_BASE_URL}/admin/fleets/`
export const DELETE_FLEETS_API = `${API_JWT_BASE_URL}/admin/fleets/`
export const GET_FLEET_DETAIL_API = `${API_JWT_BASE_URL}/admin/fleets/details/`
export const GET_FLEET_TREE_API = `${API_JWT_BASE_URL}/admin/fleets/getfleettree`
export const GET_FLEET_TREE_ADMIN_API = `${API_JWT_BASE_URL}/admin/fleets/getallfleettree`

export const FLEET_QUERY_KEYS = {
  GET_FLEET_GROUP: 'getFleetGroup',
  GET_ALL_FLEETS: 'getAllFleets',
  SEARCH_FLEETS: 'searchFleets',
  CREATE_FLEET: 'createFleet',
  UPDATE_FLEET: 'updateFleet',
  DELETE_FLEETS: 'deleteFleets',
  GET_FLEET_DETAIL: 'detailFleet',
  GET_FLEET_TREE: 'fleetTree',
  GET_FLEET_TREE_ADMIN: 'GET_FLEET_TREE_ADMIN'
}
